// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2x9Oq","header":"ReportDetails_header__3wVE6","title":"ReportDetails_title__1_MKs","left":"ReportDetails_left__23Nb7"};